// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3H5hn","icon":"SortAdornment_icon__YvMD-","up":"SortAdornment_up__h0V8r","down":"SortAdornment_down__1JAWy","active":"SortAdornment_active__p_X1x"};